import React from "react";
import "./News.scss";

import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import Contant from "../../Contant";

import SlideNew from "../../components/slidernew/SlideNew";


import CardServiceNew from "../../components/cardservicenew/CardServiceNew";
import Pagination from "@mui/material/Pagination";
import usePaginations from "../../Paginations";

import ComponentFinance from "../morenew/finance/Finance";
import ComponentPlaneTicket from "../morenew/planticket/PlanTicket";
import ComponentTicket from "../morenew/ticket/Ticket";
import ComponentMore from "../morenew/more/More";


const News = (props) => {

  const [finance, setFinance] = useState(false);
  const [air, setAir] = useState(false);
  const [ticket, setTicket] = useState(false);
  const [more, setMore] = useState(false);

  const [all, setAll] = useState(true);

  const allOnClick = () => {
    setAll(true);
    setFinance(false);
    setAir(false);
    setMore(false);
    setTicket(false);
  };

  const financeOnClick = () => {
    setFinance(true);
    setAir(false);
    setMore(false);
    setTicket(false);
    setAll(false);
  };

  const airOnClick = () => {
    setAir(true);
    setFinance(false);
    setMore(false);
    setTicket(false);
    setAll(false);
  };

  const ticketOnClick = () => {
    setTicket(true);

    setFinance(false);
    setMore(false);
    setAir(false);
    setAll(false);
  };

  const moreOnClick = () => {
    setMore(true);

    setFinance(false);
    setTicket(false);
    setAir(false);
    setAll(false);
  };

  const [datas, setDatas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=news",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });
      const datakey = response.data.news;

      setDatas(() => {
        let allNews = [];
        for (let j in datakey) {
          allNews = allNews.concat(datakey[j]);
        }
        return allNews;
      });
    };
    fetchData();
  }, [props]);

  // /----------------------------------------/

  const getData = datas.find((item) => item.id);

  const getContent = [];

  const content = "content";

  for (let list in getData) {
    if (list === content) {
      getContent.push(`${getData[list]}`);
    }
  }

  // get post detail

  function load_home(e) {
    (e || window.event).preventDefault();

    fetch(Contant + "api/data/contents/" + getContent)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("content").innerHTML = html;
      })
      .catch((error) => {
        console.warn(error);
      });
  }
  load_home();

  let [page, setPage] = useState(1);
  const PER_PAGE = 9;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  // console.log(_DATA)

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div>
      <div className="main_news">
        {datas.slice(0, 1).map((item, index) => (
          <div key={index}>
            <Link to={`/Post/detail/${item.id}`}>
              <div className="frame_top_news">
                <div className="frame_title_img_news">
                  <h2>Tin tức nổi bật</h2>
                  <div className="frame_img_news_top">
                    <img
                      src={Contant + "api/data/images/" + item.coverPhoto}
                      alt=""
                    />
                  </div>
                </div>

                <div className="frame_title_contents_news">
                  <p>{item.date}</p>
                  <h1>{item.title}</h1>
                  <div className="element_contentss">
                    <div id="content" className="element_contentss"></div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="style_background_slidenews_new">
        <h2>Tin mới nhất</h2>
        <SlideNew />
      </div>

      <div className="frame_news_themmenu">
        <h1>Tin Tức</h1>

      

        <div className="main_frame">
          <div>
            <button
              className={all === true ? "active_themeMenu" : "nonactive"}
              onClick={() => allOnClick()}
            >
              Tất cả
            </button>
            <button
              className={finance === true ? "active_themeMenu" : "nonactive"}
              onClick={() => financeOnClick()}
            >
              Tài chính
            </button>
            <button
              className={air === true ? "active_themeMenu" : "nonactive"}
              onClick={() => airOnClick()}
            >
              Vé máy bay
            </button>
            <button
              className={ticket === true ? "active_themeMenu" : "nonactive"}
              onClick={() => ticketOnClick()}
            >
              Vé xe
            </button>
            <button
              className={more === true ? "active_themeMenu" : "nonactive"}
              onClick={() => moreOnClick()}
            >
              Khác
            </button>
          </div>

          <div>
            {all === true ? (
              <>
                {" "}
                <div className="style_frame_main_card_newss">
                  <div className="frame_service_item_new">
                    {_DATA.currentDatas().map((item, index) => (
                      <div key={index}>
                        <CardServiceNew
                          Title={item.title}
                          image={
                            "https://tiendungfinance.com.vn/api/data/images/" +
                            item.coverPhoto
                          }
                          date={item.date}
                          id={item.id}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="frame_piantion_news">
                  <Pagination
                    count={count}
                    size="small"
                    page={page}
                    variant="outlined"
                    shape="rounded"
                    onChange={handleChange}
                  />
                </div>
              </>
            ) : (
              ""
            )}
            {finance === true ? <ComponentFinance/> : ""}
            {air === true ? <ComponentPlaneTicket/> : ""}
            {ticket === true ? <ComponentTicket/> : ""}
            {more === true ? <ComponentMore/> : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
